var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityOfLife2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8878 53.0256L29.6579 32.5546C29.3514 32.0804 28.8355 31.7949 28.282 31.7949C27.7286 31.7949 27.2126 32.0804 26.9061 32.5546L13.6762 53.0256C12.9442 54.1584 13.7347 55.6778 15.0522 55.6778H41.5119C42.8315 55.6778 43.6187 54.1561 42.8878 53.0256Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.513 55.6778H28.2832V31.7949C28.8367 31.7949 29.3526 32.0804 29.6591 32.5546L42.889 53.0256C43.6199 54.1561 42.8327 55.6778 41.513 55.6778Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.506 33.5008C56.506 34.4425 55.7651 35.2068 54.8522 35.2068H1.71233C0.799465 35.2068 0.0585938 34.4425 0.0585938 33.5008C0.0585938 32.5592 0.799465 31.7949 1.71233 31.7949H54.8522C55.7651 31.7949 56.506 32.5592 56.506 33.5008Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5069 33.5008C56.5069 34.4425 55.766 35.2068 54.8532 35.2068H28.2832V31.7949H54.8532C55.766 31.7949 56.5069 32.5592 56.5069 33.5008Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9296 4.5C38.5462 4.5 33.3535 9.85658 33.3535 16.4414C33.3535 23.0263 38.5462 28.3828 44.9296 28.3828C51.313 28.3828 56.5058 23.0263 56.5058 16.4414C56.5058 9.85658 51.313 4.5 44.9296 4.5Z",
    fill: "#FF7B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5058 16.4414C56.5058 23.0263 51.3131 28.3828 44.9297 28.3828V4.5C51.3131 4.5 56.5058 9.85658 56.5058 16.4414Z",
    fill: "#FF435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9288 24.9713C49.4955 24.9713 53.1975 21.1525 53.1975 16.4417C53.1975 11.7309 49.4955 7.91211 44.9288 7.91211C40.3622 7.91211 36.6602 11.7309 36.6602 16.4417C36.6602 21.1525 40.3622 24.9713 44.9288 24.9713Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1983 16.4417C53.1983 21.1455 49.4896 24.9713 44.9297 24.9713V7.91211C49.4896 7.91211 53.1983 11.7379 53.1983 16.4417Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8903 16.441C49.8903 17.3827 49.1494 18.1469 48.2366 18.1469H44.9291C44.0163 18.1469 43.2754 17.3827 43.2754 16.441V13.0292C43.2754 12.0875 44.0163 11.3232 44.9291 11.3232C45.842 11.3232 46.5829 12.0875 46.5829 13.0292V14.7351H48.2366C49.1494 14.7351 49.8903 15.4993 49.8903 16.441Z",
    fill: "#61729B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8909 16.441C49.8909 17.3827 49.15 18.1469 48.2372 18.1469H44.9297V11.3232C45.8425 11.3232 46.5834 12.0875 46.5834 13.0292V14.7351H48.2372C49.15 14.7351 49.8909 15.4993 49.8909 16.441Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7444 4.5C9.00913 4.5 6.7832 6.79616 6.7832 9.61775C6.7832 12.4393 9.00913 14.7355 11.7444 14.7355C14.4797 14.7355 16.7056 12.4393 16.7056 9.61775C16.7056 6.79616 14.4797 4.5 11.7444 4.5Z",
    fill: "#7ED8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7452 14.7354C7.18533 14.7354 3.47656 18.5612 3.47656 23.2649V26.6768C3.47656 27.6184 4.21743 28.3827 5.13029 28.3827H18.3601C19.273 28.3827 20.0139 27.6184 20.0139 26.6768V23.2649C20.0139 18.5612 16.3051 14.7354 11.7452 14.7354Z",
    fill: "#7ED8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7441 14.7355V4.5C14.4794 4.5 16.7053 6.79616 16.7053 9.61775C16.7053 12.4393 14.4794 14.7355 11.7441 14.7355Z",
    fill: "#6AA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0128 23.2649V26.6768C20.0128 27.6184 19.2719 28.3827 18.3591 28.3827H11.7441V14.7354C16.304 14.7354 20.0128 18.5612 20.0128 23.2649Z",
    fill: "#6AA9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.4474,
    height: 58.2287,
    fill: "white",
    transform: "translate(0.0585938 0.974609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityOfLife2);
export default __webpack_public_path__ + "static/media/quality_of_life_2.b9e36b55c4154643028e7c0c262905fb.svg";
export { ForwardRef as ReactComponent };